import DiscoverBrandColumn from './DiscoverBrandColumn';

export default DiscoverBrandColumn;
